import { useRef, useState } from "react";
import * as S from "./ChatbotInitialSelector.style"
import { useMutation } from "@apollo/client";
import { MUTATION_CHAT_BOX } from "../../../../../../../../graphql/mutations/Chat";
import { useTranslation } from "react-i18next";
import useDoctorData from "../../../../../../../../hooks/useDoctorData";
import ZaialoadingPoints from "../../../../../../../zaiaComponents/zaiaLoadingPoints";
import ChatbotInput from "../../../../chatbotInput";

// import Message from "../../message";
import useUploadTempDoc from "../../../../../../../../hooks/useUploadTempDoc";
import useUploadTempSeveralDocs from "../../../../../../../../hooks/useUploadTempSeveralDocs";
import useFileProcessor from "../../../../../../../../hooks/useImageProcessor";
import ZaiaReaction from "../../../../../../../zaiaComponents/zaiaReaction";
import Message from "../../../../../../algorithms/components/message";
import MessageType from "../../../../messageType";

// pipes
import YesOrNo from "../../../../yesOrNo";
import FlorenzButton from "../../../../../../../florenzComponents/florenzButton";

const logoZaiaAlert = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/reaction-error-data.svg`;

function ChatbotInitialSelector(
    {
      messages,
      setMessages,
      algorithm,
      patientData,
      handleSubmitSeveralFiles,
      handleSubmit,
      uploadMultiDocs,
      uploadTempDoc,
      deleteDocs,
      tempDocs,
      dataDocs,
      fileInput,
      setPatientData
    }
) {

  const { t, i18n: { language } }= useTranslation("global");

  return (
    <S.ChatbotInitialSelector>
      <div className="file-selection"
        onClick={() => tempDocs.length === 0 && fileInput.current.click()}
        style={{cursor: tempDocs.length === 0 ? 'pointer' : 'default'}}
      >
        {
            tempDocs.length === 0
            ? <div className="file-selection__empty">
              <div className="file-selection__empty-icon">
                <i className="icon zaia-icono-gallery"></i>
              </div>
              <div className="file-selection__empty-text">
                {t("chatbotAI.imageReading.inputCondition")}
              </div>
            </div>
            : <div className="file-selected">
              <div className="file-selected__top">
                <div className="file-selected__top-button">
                  <FlorenzButton
                    size="s"
                    typeStyle={"secondaryWhite"}
                    text={t("globally.cancel")}
                    widthComplete={true}
                    onClick={() => {
                      deleteDocs()
                    }}
                  />
                </div>
                <div className="file-selected__top-patient">
                  <div className="label">{t("globally.patient")}</div>
                  <div className="name">{patientData.name}</div>
                </div>
              </div>
              <div className="files">
              {
                  // algorithm === "prostate"
                  // ? 
                  tempDocs.map((doc, index) => {
                    return (
                      <div className="file" key={index}>
                      <div className="file__preview">
                          {
                          doc?.type?.includes("image") 
                          ? <div className="file__img">
                              <img src={
                              doc?.url || URL.createObjectURL(doc)
                              } alt="" />
                          </div>
                          : <div className="file__icon">
                              <i className="icon zaia-icon-file"></i>
                          </div>
                          }
                      </div>
                      <div className="file__title">
                          {doc?.name || dataDocs[index]?.name || "Archivo"}
                      </div>
                      </div>
                    )
                  })
                  // : <div className="file">
                  // <div className="file__preview">
                  //     {
                  //     tempDoc?.type?.includes("image") 
                  //     ? <div className="file__img">
                  //         <img src={
                  //         tempDoc?.url || URL.createObjectURL(tempDoc)
                  //         } alt="" />
                  //     </div>
                  //     : <div className="file__icon">
                  //         <i className="icon zaia-icon-file"></i>
                  //     </div>
                  //     }
                  // </div>
                  // <div className="file__title">
                  //     {tempDoc?.name || dataDoc?.name || "Archivo"}
                  // </div>
                  // </div>
              }
              </div>
              <div className="file-selected__bottom">
                <div className="label">
                  {t("chatbotAI.imageReading.contextAnalysis")}
                </div>
                <div className="input">

                  <ChatbotInput
                    // handleSubmit={
                    //   severalImgs
                    //   ? handleSubmitSeveralFiles
                    //   : handleSubmit
                    // }
                    handleSubmit={
                      handleSubmitSeveralFiles
                    }
                    handleClickUpload={() => fileInput.current.click()}
                    // tempDocs={severalImgs ? tempDocs : [tempDoc]}
                    tempDocs={tempDocs}
                    filesSelectorActived={false}
                    smallInput={true}
                  />
                </div>
              </div>
            </div>        
        }
      </div>
      {
        tempDocs.length === 0 &&
        <div className="footer-selection">
          <div className="footer-selection__button">
            <FlorenzButton
              size="s"
              typeStyle={"secondary"}
              text={t("globally.cancel")}
              widthComplete={true}
              onClick={() => {
                setPatientData(null)
                deleteDocs()
              }}
            />
          </div>
          <div className="footer-selection__patient">
            <div className="label">{t("globally.patient")}</div>
            <div className="name">{patientData?.name}</div>
          </div>
        </div>
      }
      <div className="alert-message">
        {t("chatbotAI.imageReading.warningChatbot")}
      </div>
      {/* <div className="chatbot-footer">
        
        <ChatbotInput
          handleSubmit={
            severalImgs
            ? handleSubmitSeveralFiles
            : handleSubmit
          }
          handleClickUpload={() => fileInput.current.click()}
          tempDocs={severalImgs ? tempDocs : [tempDoc]}
          filesSelectorActived={true}
        />
      </div> */}
    </S.ChatbotInitialSelector>
  );

}

export default ChatbotInitialSelector;
